<template>
    <b-modal id="modal-1" title="Please Login" hide-footer>
        <div style="text-align:center">
            <form @submit.prevent="doLogin">
                <div class="form-group">
                    <input type="email" class="form-control" v-model='email' placeholder="Enter your email" />
                </div>
                <div class="form-group">
                    <input type="password" class="form-control" v-model='password' placeholder="Enter your password" />
                </div>
                <button type="submit" class="btn btn-primary btn-block">Login</button>
            </form>
        </div>    
   </b-modal>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            // url: 'http://localhost:3000'
            url: 'https://dry-savannah-57278.herokuapp.com'
        }
    },
    methods: {
        doLogin() {
           axios({
               url: `${this.url}/auth/login`,
               method: 'post',
               data: {
                   email: this.email,
                   password: this.password
               }
           })
           .then(response=>{
               this.resetForm()
               localStorage.setItem('token',response.data.token)
               localStorage.setItem('name',response.data.name)
               this.$root.$emit('bv::hide::modal','modal-1')
               this.$store.commit('LOGIN')
           })
           .catch(err=>{
               swal("Error!",err.response.data.message,"error")
           })
       },
       resetForm() {
           this.email = "",
           this.password= ""
       },
    },
}
</script>